export default __webpack_public_path__ + "static/media/home.14c4b704.jpg";